import LoaderPage from 'components/ui/feedback/LoaderPage'
import { lazy } from 'react'
import { Route, RouteProps, Routes } from 'react-router-dom'

const ReportsPage = lazy(() => import('pages/reports/page'))
const ReportsDetailPage = lazy(() => import('pages/reports/[reportsId]/page'))
const AppReportsPage = lazy(() => import('pages/reports/appReports/page'))

const ReportsRoutes: React.FunctionComponent<RouteProps> = () => {
  return (
    <Routes>
      <Route path="/" element={<LoaderPage content={<ReportsPage />} />} />
      <Route path="/summary" element={<LoaderPage content={<ReportsDetailPage />} />} />
      <Route path="/:reportName/:reportId/superset" element={<LoaderPage content={<ReportsDetailPage />} />} />
      <Route path="/:reportName/:reportId" element={<LoaderPage content={<AppReportsPage />} />} />
    </Routes>
  )
}

export default ReportsRoutes
